import React, { useEffect, useState } from "react";
import { Modal, Button, Form } from "react-bootstrap";
import { toast } from "react-toastify";
import AccountService from "../../Services/AccountService";
import { useAuth } from "../../Utils/Auth";

const IntroducerPercentageModal = ({
  show,
  onClose,
  userData,
  fetchData,
}) => {
  const auth = useAuth();

  const [percentage, setPercentage] = useState("");
  const [showPercentage, setShowPercentage] = useState(false);
  const [isLoading, setIsLoading] = useState(false);

  useEffect(() => {
    if (userData) {
      setPercentage(userData.adminIntropercentage ?? 0);
      setShowPercentage(
        userData.showAdminIntroPercentage ?? false
      );
    }
  }, [userData]);

  const handlePercentageUpdate = async () => {
    if (percentage === "" || percentage === null) {
      toast.error("Please enter percentage");
      return;
    }

    const numericPercentage = Number(percentage);

    if (Number.isNaN(numericPercentage)) {
      toast.error("Please enter a valid percentage");
      return;
    }

    if (numericPercentage < 0 || numericPercentage > 100) {
      toast.error("Percentage must be between 0 and 100");
      return;
    }

    try {
      setIsLoading(true);

      const data = {
        percentage: numericPercentage,
      };

      const response =
        await AccountService.updateAdminIntroPercentage(
          userData.introId,
          data,
          auth.user
        );

      toast.success(
        response?.data?.message ||
          "Percentage updated successfully"
      );

      // Refresh introducer list
      if (fetchData) {
        await fetchData();
      }
    } catch (error) {
      console.error(
        "Error updating percentage:",
        error
      );

      toast.error(
        error?.response?.data?.message ||
          "Failed to update percentage"
      );
    } finally {
      setIsLoading(false);
    }
  };

  const handleToggle = async (e) => {
    const newValue = e.target.checked;

    try {
      setIsLoading(true);

      const data = {
        showAdminIntroPercentage: newValue,
      };

      const response =
        await AccountService.toggleAdminIntroPercentage(
          userData.introId,
          data,
          auth.user
        );

      setShowPercentage(newValue);

      toast.success(
        response?.data?.message ||
          "Percentage visibility updated"
      );

      if (fetchData) {
        await fetchData();
      }
    } catch (error) {
      console.error(
        "Error updating percentage visibility:",
        error
      );

      toast.error(
        error?.response?.data?.message ||
          "Failed to update percentage visibility"
      );
    } finally {
      setIsLoading(false);
    }
  };

  if (!userData) {
    return null;
  }

  return (
    <Modal
      show={show}
      onHide={onClose}
      centered
      backdrop="static"
    >
      <Modal.Header closeButton>
        <Modal.Title>
          Introducer Percentage
        </Modal.Title>
      </Modal.Header>

      <Modal.Body>
        <div className="mb-3">
          <label className="form-label font-weight-bold">
            Introducer
          </label>

          <input
            type="text"
            className="form-control"
            value={userData.userName || ""}
            disabled
          />
        </div>

        <div className="mb-3">
          <label className="form-label font-weight-bold">
            Admin Intro Percentage (%)
          </label>

          <div className="input-group">
            <input
              type="number"
              className="form-control"
              min="0"
              max="100"
              step="0.01"
              value={percentage}
              onChange={(e) =>
                setPercentage(e.target.value)
              }
              placeholder="Enter percentage"
            />

            <div className="input-group-append">
              <span className="input-group-text">
                %
              </span>
            </div>
          </div>
        </div>

        <div className="d-flex justify-content-between align-items-center border rounded p-3">
          <div>
            <div className="font-weight-bold">
              Show Percentage to Introducer
            </div>

            <small className="text-muted">
              Allow the introducer to see the admin percentage.
            </small>
          </div>

          <Form.Check
            type="switch"
            id="show-admin-intro-percentage"
            checked={showPercentage}
            onChange={handleToggle}
            disabled={isLoading}
            style={{
              transform: "scale(1.3)",
            }}
          />
        </div>

        <div className="mt-3">
          <small className="text-muted">
            Current Percentage:{" "}
            <strong>{percentage}%</strong>
          </small>
        </div>
      </Modal.Body>

      <Modal.Footer>
        <Button
          variant="secondary"
          onClick={onClose}
          disabled={isLoading}
        >
          Close
        </Button>

        <Button
          variant="primary"
          onClick={handlePercentageUpdate}
          disabled={isLoading}
        >
          {isLoading
            ? "Updating..."
            : "Update Percentage"}
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default IntroducerPercentageModal;